<template>
  <v-card outlined class="kpi" :class="{ 'kpi--acento': acento }">
    <div class="kpi-icono" :class="`${color} lighten-5`">
      <v-icon :color="color" small>{{ icono }}</v-icon>
    </div>
    <div class="kpi-cuerpo">
      <div class="kpi-titulo">{{ titulo }}</div>
      <v-progress-circular v-if="cargando" :size="18" :width="2" color="primary" indeterminate />
      <div v-else class="kpi-valor" :class="acento ? `${color}--text` : ''">{{ valor }}</div>
    </div>
  </v-card>
</template>

<script>
// Tarjeta compacta de indicador: ícono a la izquierda, etiqueta y valor a la derecha.
// La usan las dos sub-pestañas de "Carga de OTs" para que los totales se vean iguales.
export default {
  name: 'CargaOtsTarjetaKpi',

  props: {
    titulo: { type: String, required: true },
    valor: { type: [String, Number], default: '' },
    icono: { type: String, default: 'mdi-information-outline' },
    // Nombre de color de Vuetify ('primary' no sirve aquí: el fondo usa la variante lighten-5).
    color: { type: String, default: 'blue-grey' },
    cargando: { type: Boolean, default: false },
    // Pinta el número con el color del ícono: se reserva para lo que exige atención.
    acento: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.kpi {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  height: 100%;
}

.kpi--acento {
  border-width: 1px;
}

.kpi-icono {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  flex: 0 0 auto;
}

.kpi-cuerpo {
  min-width: 0;
}

.kpi-titulo {
  font-size: 11px;
  line-height: 1.2;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.6);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.kpi-valor {
  font-size: 22px;
  font-weight: 600;
  line-height: 1.25;
}
</style>
